import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ImportSvg from '../../../assets/icons/nav/import.svg?raw';

export const ImportIcon = (props) => <CustomSVG svg={ImportSvg} preserveColors {...props} />;
